<template>
  <div class="container-help" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop:${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <span class="tit-left">{{ $t('lang.BaseCommon.k069') }} {{ $t('lang.FAQ.k022') }}</span>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <div class="intro">{{ $t('lang.RealVerifyQA.k001') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k002') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k003') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k004') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k005') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k006') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k007') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k008') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k009') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k010') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k011') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k012') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k013') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k014') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k015') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k016') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k017') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k018') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k019') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k020') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k021') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k022') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k023') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k024') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k025') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k026') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k027') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k028') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k029') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k030') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k031') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k032') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k033') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k034') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k035') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k036') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k037') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k038') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k039') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k040') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k041') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k042') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k043') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k044') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k045') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k046') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k047') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k048') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k049') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k050') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k051') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k052') }}</div>

      <div class="tit">{{ $t('lang.RealVerifyQA.k053') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k054') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k055') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k056') }}</div>
      <div>{{ $t('lang.RealVerifyQA.k057') }}</div>
    </div>
  </div>
</template>

<script>
import { getBaseFeature } from '@/assets/style/variable'

export default {
  name: 'RealVerifyQA',
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
  },
}
</script>

<style lang="scss" scoped>
.container-help {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  .custom-nav-block {
    background-color: #ffffff;
  }
  .main {
    padding: 0 16px 16px 16px;
    color: #666666;
    font-family: var(--string-font);
    font-size: var(--fs-14);
    font-weight: var(--fw-400);
    line-height: var(--lh-body-20);
    .intro {
      margin-bottom: 16px;
    }
    .intro + .tit {
      margin-top: 0;
    }
    .tit {
      color: #333333;
      margin: 16px 0 8px 0;
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-700);
      line-height: var(--lh-body-20);
    }
    ::v-deep b {
      color: #4188f1 !important;
    }
  }
}
</style>
